module.exports = __webpack_public_path__ + "static/favicon-96840e82db974770c6a58e7a0d9490c4.png";